import {
  Button,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  TablePagination,
  Typography,
} from "@mui/material";
import { useOutletContext } from "react-router";
import { ServoTypMitBerechtigungen } from "../../api";
import { useState } from "react";
import {
  useAddTestSzenarioToServoTyp,
  useGetTestSzenarienForServoTyp,
  useGetUnassignedTestSzenarien,
  useRemoveTestSzenarioFromServoTyp,
} from "./data";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

export default function ServoTypDetailsTestszenarios() {
  const { servoTyp } = useOutletContext<{
    servoTyp: ServoTypMitBerechtigungen;
  }>();
  const [seiteAll, setSeiteAll] = useState(0);
  const [maxAll, setMaxAll] = useState(25);
  const [seite, setSeite] = useState(0);
  const [max, setMax] = useState(25);

  const zugeordneteTestszenarios = useGetTestSzenarienForServoTyp({
    id: servoTyp.id,
    seite: seite,
    max: max,
  });
  const testSzenariosPage = useGetUnassignedTestSzenarien({
    id: servoTyp.id,
    seite: seiteAll,
    max: maxAll,
  });

  const { mutateAsync: addTestSzenarioToServoTyp } =
    useAddTestSzenarioToServoTyp();

  const { mutateAsync: removeTestSzenarioFromServoTyp } =
    useRemoveTestSzenarioFromServoTyp();

  return (
    <>
      <Stack spacing={"5%"} direction="row">
        <Paper square sx={{ width: "45%" }}>
          <Typography variant="h6" sx={{ margin: "7px" }}>
            Alle Testszenarios
          </Typography>
          <List>
            {testSzenariosPage.elemente.map((e) => (
              <ListItem key={e.id}>
                <ListItemText>{e.name}</ListItemText>
                <Button
                  variant="contained"
                  onClick={() =>
                    addTestSzenarioToServoTyp({
                      testSzenarioId: e.id,
                      servoTypId: servoTyp.id,
                    })
                  }
                >
                  <ArrowRight />
                </Button>
              </ListItem>
            ))}
          </List>
          <TablePagination
            page={testSzenariosPage.seite}
            rowsPerPage={testSzenariosPage.max}
            count={testSzenariosPage.anzahlElemente}
            onPageChange={(_, p) => setSeiteAll(p)}
            onRowsPerPageChange={(e) => setMaxAll(parseInt(e.target.value, 10))}
            sx={{ borderBottom: 0 }}
          />
        </Paper>
        <Paper square sx={{ width: "45%" }}>
          <Typography variant="h6" sx={{ margin: "7px" }}>
            Zugeordnete Testszenarios
          </Typography>
          <List>
            {zugeordneteTestszenarios.elemente.map((e) => (
              <ListItem key={e.id}>
                <Stack direction="row" spacing={1}>
                  <Button
                    variant="contained"
                    onClick={() =>
                      removeTestSzenarioFromServoTyp({
                        testSzenarioId: e.id,
                        servoTypId: servoTyp.id,
                      })
                    }
                  >
                    <ArrowLeft />
                  </Button>
                  <ListItemText>{e.name}</ListItemText>
                </Stack>
              </ListItem>
            ))}
          </List>
          <TablePagination
            page={testSzenariosPage.seite}
            rowsPerPage={testSzenariosPage.max}
            count={testSzenariosPage.anzahlElemente}
            onPageChange={(_, p) => setSeite(p)}
            onRowsPerPageChange={(e) => setMax(parseInt(e.target.value, 10))}
            sx={{ borderBottom: 0 }}
          />
        </Paper>
      </Stack>
    </>
  );
}
